import { motion } from "framer-motion";
import { Users, Linkedin } from "lucide-react";

export const Founders = () => {
    return (
        <section id="founders" className="relative bg-white py-24 md:py-32">
            <div className="max-w-6xl mx-auto px-6 md:px-12 lg:px-16">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-start">
                    <div className="md:col-span-4">
                        <div className="inline-flex items-center gap-2 label-eyebrow text-[#0052CC]">
                            <Users size={14} strokeWidth={2.5} />
                            // Our Story
                        </div>
                        <div className="mt-10 border-t-2 border-[#0052CC] pt-6">
                            <div className="font-display text-6xl md:text-7xl font-extrabold text-[#091524] leading-none">
                                70<span className="text-[#0052CC]">+</span>
                            </div>
                            <div className="mt-3 label-eyebrow text-[#091524]/50">
                                Years combined experience
                            </div>
                            <div className="mt-1 text-sm text-[#475569]">
                                Offshore &amp; subsea operations
                            </div>
                        </div>
                    </div>

                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 0.6 }}
                        className="md:col-span-8"
                    >
                        <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-extrabold text-[#091524] leading-[1.1] tracking-tight">
                            Built by operators.<br />
                            <span className="text-[#091524]/40">Trusted by operators.</span>
                        </h2>

                        <p className="mt-8 text-lg text-[#475569] leading-relaxed">
                            Apex Pro was founded by{" "}
                            <span className="text-[#091524] font-semibold">Allan and Andrew</span>,
                            who together bring over{" "}
                            <span className="text-[#091524] font-semibold">
                                70 years of hands-on experience
                            </span>{" "}
                            in offshore subsea operations.
                        </p>

                        <p className="mt-5 text-lg text-[#475569] leading-relaxed">
                            They recognised the need for a modern, intelligent platform that
                            simplifies safety reporting &mdash; one that combines real-world
                            operational knowledge with innovative technology. Both are committed to
                            helping organisations improve their safety performance.
                        </p>

                        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-6">
                            {[
                                {
                                    name: "Allan Nairn",
                                    initials: "AN",
                                    role: "Co-Founder & CEO",
                                    tag: "Offshore Subsea Operations",
                                    linkedin: "https://www.linkedin.com/in/allan-nairn-58640316/",
                                },
                                {
                                    name: "Andrew Nairn",
                                    initials: "AN",
                                    role: "Co-Founder & Operations Manager",
                                    tag: "Offshore Subsea Operations",
                                    linkedin: "https://www.linkedin.com/in/andrew-nairn-945674424/",
                                },
                            ].map((p) => (
                                <div
                                    key={p.name}
                                    className="border border-[#091524]/10 rounded-sm p-6 hover:border-[#0052CC] hover:-translate-y-0.5 transition-all duration-300"
                                >
                                    <div className="flex items-center gap-4">
                                        <div className="w-12 h-12 bg-[#091524] flex items-center justify-center rounded-sm">
                                            <span className="font-display text-sm font-extrabold text-white tracking-wider">
                                                {p.initials}
                                            </span>
                                        </div>
                                        <div>
                                            <div className="font-display font-bold text-[#091524] text-lg">
                                                {p.name}
                                            </div>
                                            <div className="text-sm text-[#0052CC] font-semibold">
                                                {p.role}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-4 flex items-center justify-between">
                                        <div className="label-eyebrow text-[#091524]/50 text-[0.65rem]">
                                            {p.tag}
                                        </div>
                                        <a
                                            href={p.linkedin}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            data-testid={`founder-linkedin-${p.name.split(" ")[0].toLowerCase()}`}
                                            aria-label={`${p.name} on LinkedIn`}
                                            className="inline-flex items-center gap-1.5 text-[#0A66C2] hover:text-[#091524] font-semibold text-xs transition-colors"
                                        >
                                            <Linkedin size={16} strokeWidth={2} />
                                            LinkedIn
                                        </a>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
};
